module.exports = __webpack_public_path__ + "media/bet_success.81cec883.mp3";